import dayjs from "dayjs";
import { ListPage } from "../../components/ListPage";
import { SiteLabel } from "../../components/SiteLabel";
import { DT_FORMATS } from "../../helpers/constants";
import type { GIN } from "../../api-models";

export default function IssuesListPage() {
  return (
    <ListPage<GIN>
      title="Issues"
      endpoint="/gins"
      searchPlaceholder="Search doc no, vehicle or driver..."
      linkTo={(r) => `/issues/${r.id}`}
      columns={[
        { title: "Doc No", dataIndex: "docNo", sorter: true },
        { title: "Request", render: (_, r) => r.mrq?.docNo },
        { title: "Site", render: (_, r) => <SiteLabel site={r.site} /> },
        { title: "Dispatched at", dataIndex: "dispatchedAt", sorter: true, render: (v) => dayjs(v).format(DT_FORMATS.dateTime) },
      ]}
      renderCard={(r) => (
        <div>
          <strong>{r.docNo}</strong>
          <div><SiteLabel site={r.site} /></div>
        </div>
      )}
    />
  );
}
